import { render, staticRenderFns } from "./callListMod.vue?vue&type=template&id=3a66bd3b&scoped=true&"
import script from "./callListMod.vue?vue&type=script&lang=js&"
export * from "./callListMod.vue?vue&type=script&lang=js&"
import style0 from "./callListMod.vue?vue&type=style&index=0&id=3a66bd3b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a66bd3b",
  null
  
)

export default component.exports